import { Component, EventEmitter, Input, Output } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { InstallationItem } from '../../../models/installation-item.model'

@Component({
    selector: 'app-customer-relations-list',
    templateUrl: './customer-relations-list.component.html',
    styleUrls: ['./customer-relations-list.component.scss'],
    standalone: false,
})
export class CustomerRelationsListComponent {
    @Input() public isExpanded = false
    @Input() public installations: InstallationItem[] = []
    @Input() public isSingleInstallationView = false
    @Input() public isBusiness = false
    @Input() public formGroup: UntypedFormGroup
    @Input() public selectedItemId?: number

    @Output() public selectInstallation = new EventEmitter<InstallationItem>()

    public onSelectInstallation(installation: InstallationItem): void {
        this.selectInstallation.emit(installation)
    }

    public get hasInstallations(): boolean {
        return (this.installations ?? []).length > 0
    }

    public get installationControls(): InstallationItem[] {
        return this.installations ?? []
    }
}
